import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Standalone website admin session (independent of the sometimes-asleep upstream
// RelayRigs app) — httpOnly cookie set by POST /api/admin/login.
export const useAdminSession = () => {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/admin/me`)
      .then(({ data }) => setAdmin(data))
      .catch(() => setAdmin(null))
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/admin/login`, { email, password });
    setAdmin({ email: data.email });
  };

  const logout = async () => {
    await axios.post(`${API}/admin/logout`);
    setAdmin(null);
  };

  return { admin, checking, login, logout };
};
